import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const cmgEntityKeyColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'linkedCmgEntityKey',
  headerName: 'Linked CMG Entity Key',
  initialHide: true,
};
